/************************************************************
 Consult Process Namespace
 ************************************************************/

 window.consultProcessNS = {
    // Private Variables
    _row: null,
    _action: null,
    _callback: null,
    // Execute Action
    executeAction: function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        consultProcessNS._action = action;
        consultProcessNS._row = row;
        consultProcessNS._callback = callback;

        // Cancel Surgery Process
        if (actionId == 3) {
            //consultProcessNS.openReason(consultProcessNS.updateStateSurgicalProcess);
            consultProcessNS.executeGenericActionWithReason();
        } else if (actionId == 12) {
            consultProcessNS.openReason(consultProcessNS.finalizePhysiotherapyReasonModalHandler);
        } else if (actionId == 14) {
            consultProcessNS.reopenConsultProccessHandler();

        } else {
            consultProcessNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction: function () {
        workflow.executeAction(consultProcessNS._action, consultProcessNS._callback, consultProcessNS._row);
    },
    // Open Reason
    openReason: function (callback) {
        Hades.showLoading();

        var params = {
            task_id: consultProcessNS._action.task_id,
            wf_id: consultProcessNS._action.wf_id,
            wf_status_id: consultProcessNS._action.to_state_id,
            wf_action_id: consultProcessNS._action.wf_action_id
        };

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content: data, autoScale: true, autoDimensions: true});

                debug.log("cenas1");
                debug.log("callback", callback);

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                consultProcessNS._callback(false, consultProcessNS._action, consultProcessNS._row);
            });
    },

    // Finalize Physiotherapy
    finalizePhysiotherapyReasonModalHandler: function (event, data) {
        //$.fancybox.close(true);

        var params = {
            task_id:consultProcessNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:consultProcessNS._row.wf_id,
            wf_status_id:consultProcessNS._row.wf_status_id,
            wf_action_id:data.actionId};

        $.getJSON('/treatment/check_process_month_entity_invoiced', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                /*var process_month_end_date = new Date(params.date.substr(6, 4),
                 params.date.substr(3, 2),
                 '01');
                 */
                var process_month_end_date = params.date.substr(6, 4) +
                    params.date.substr(3, 2) +
                    '01';

                debug.log('check_entity_invoiced', data, params.date, params.hour);
                debug.log(
                    params.date.substr(6, 4),
                    params.date.substr(3, 2),
                    '01',
                    process_month_end_date
                );

                if (data.length > 0) {
                    //compare process date (year_month) for finalize with sale_transaction (year_month); process end_date need to be after sale_transaction finalized_date;
                    //var st_date = '';
                    debug.log(process_month_end_date,
                        (   data[data.length - 1].sale_transaction_date_desc.substr(6, 4) +
                            data[data.length - 1].sale_transaction_date_desc.substr(3, 2) +
                            '01'
                        ),
                        data[data.length - 1].sale_transaction_date_desc);

                    if ((data[data.length - 1].sale_transaction_date_desc.substr(6, 4) +
                            data[data.length - 1].sale_transaction_date_desc.substr(3, 2) +
                            '01'
                        ) >= process_month_end_date) {
                        //DO NOT FINALIZE

                        bootbox.alert(data[0].finalized_message.replace('#sale_transaction_date#', data[data.length - 1].sale_transaction_date_desc),
                            function () {
                            });

                    } else {
                        //FINALIZE
                        $.fancybox.close(true);
                        consultProcessNS.finalizeConsultProcess(params);

                        //IF ASKED TO PUT THAT SPECIFIC "exception message", make a new "else if" with this code.
                        //check if is the same month of the choosen end_date
                        /*$.each(data, function( index, value ) {

                         var st_date = value.sale_transaction_date_desc.substr(6, 4) +
                         value.sale_transaction_date_desc.substr(3, 2) +
                         '01';

                         debug.log(index, value, process_month_end_date, st_date);

                         if (process_month_end_date == st_date){
                         bootbox.alert('O processo já foi facturado no mês da data seleccionada, a data de fim terá que ser superior.');
                         }else{
                         //all_dates = all_dates + ' | ' + value.sale_transaction_date_desc;
                         }

                         });*/
                    }
                }
                else {
                    $.fancybox.close(true);
                    consultProcessNS.finalizeConsultProcess(params);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
            });
    },

    finalizeConsultProcess: function (params) {
        $.fancybox.close(true);

        Hades.showLoading();

        $.post('/consult_process/finalize_consult_process', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    consultProcessNS._callback(false, consultProcessNS._action, consultProcessNS._row);
                } else {
                    consultProcessNS._callback(true, consultProcessNS._action, consultProcessNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                consultProcessNS._callback(false, consultProcessNS._action, consultProcessNS._row);
            });
    },

    // Reopen Physiotherapy
    reopenConsultProcessReasonModalHandler: function (event, data) {

        var params = {
            task_id: consultProcessNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: consultProcessNS._action.wf_id,
            wf_status_id: consultProcessNS._action.to_state_id,
            wf_action_id: consultProcessNS._action.wf_action_id
        };

        $.getJSON('/treatment/check_process_month_entity_invoiced', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                debug.log('check_entity_invoiced', data);

                if (data.length > 0) {
                    var all_dates = '';
                    $.each(data, function (index, value) {
                        debug.log(index, value);
                        if (index == 0) {
                            all_dates = value.sale_transaction_date_desc;
                        } else {
                            all_dates = all_dates + ' | ' + value.sale_transaction_date_desc;
                        }

                    });

                    bootbox.confirm(data[0].reopen_message.replace('#sale_transaction_date#', all_dates), function (success) {
                        Hades.showLoading();

                        if (success) {

                            $.fancybox.close(true);
                            consultProcessNS.reopenConsultProcess(params);

                        } else {
                            Hades.hideLoading();
                            $.fancybox.close(true);
                            //Hades.goToPreviousScreen();
                        }
                    });
                }
                else {
                    $.fancybox.close(true);
                    consultProcessNS.reopenConsultProcess(params);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
            });
    },

    reopenConsultProcess: function (evt, data) {
        $.fancybox.close(true);

        var params = {
            task_id: consultProcessNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: consultProcessNS._row.wf_id,
            wf_status_id: consultProcessNS._row.wf_status_id,
            wf_action_id: data.actionId
        };

        Hades.showLoading();


        debug.log("reopenConsultProcess");

        $.post('/consult_process/reopen_consult_process', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    consultProcessNS._callback(false, consultProcessNS._action, consultProcessNS._row);
                } else {
                    consultProcessNS._callback(true, consultProcessNS._action, consultProcessNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                consultProcessNS._callback(false, consultProcessNS._action, consultProcessNS._row);
            });
    },

    openDateHourPicker: function (callback) {
        Hades.showLoading();

        var params = {
            task_id: consultProcessNS._action.task_id,
            wf_id: consultProcessNS._action.wf_id,
            wf_from_status_id: consultProcessNS._action.from_state_id,
            wf_status_id: consultProcessNS._action.to_state_id,
            wf_action_id: consultProcessNS._action.wf_action_id
        };

        $.get('/modal/date_hour_picker', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content: data, autoScale: true, autoDimensions: true});

                $('#date-hour-picker-modal-ct').bind('dateHourConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                consultProcessNS._callback(false, consultProcessNS._action, consultProcessNS._row);
            });
    },

    executeGenericActionWithReason: function (specific_callback) {

        debug.log('executeGenericActionWithReason');
        workflow.openGenericReasonModal(specific_callback);
    },

    // Reopen Physiotherapy
    reopenConsultProccessHandler: function () {


        $.getJSON('/treatment/check_process_month_entity_invoiced', {task_id: consultProcessNS._action.task_id, wf_id: consultProcessNS._action.wf_id})
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                debug.log('check_entity_invoiced', data);

                if (data.length > 0){
                    var all_dates = '';
                    $.each(data, function( index, value ) {
                        debug.log(index, value);
                        if (index == 0){
                            all_dates = value.sale_transaction_date_desc;
                        }else{
                            all_dates = all_dates + ' | ' + value.sale_transaction_date_desc;
                        }

                    });

                    if (data[0].actual_month_in_lot === 't') {
                        bootbox.alert(GlobalTranslations['APP_LABEL.2455']);
                    } else if (data[0].invoice_has_credit_note === 'f') {
                        bootbox.alert(GlobalTranslations['APP_LABEL.TREATMENT_ALREADY_INVOICED'].replace('#sale_transaction_date#', all_dates))
                    }else {
                        bootbox.confirm(data[0].reopen_message.replace('#sale_transaction_date#', all_dates), function (success) {
                            Hades.showLoading();

                            if (success) {

                                consultProcessNS.openReason(consultProcessNS.reopenConsultProcess);

                            } else {
                                Hades.hideLoading();
                                $.fancybox.close(true);
                                //Hades.goToPreviousScreen();
                            }
                        });
                    }
                }
                else {

                    $.getJSON('/billing/entities/verify_credential_added_to_lot', {task_id: consultProcessNS._action.task_id, wf_id: consultProcessNS._action.wf_id})
                        .done(function (data, status, xhr) {
                            Hades.checkIfUserIsAuthorized(data, status, xhr);
                            if (!data) {

                                consultProcessNS.openReason(consultProcessNS.reopenConsultProcess);

                            }
                            else {
                                bootbox.alert(GlobalTranslations['APP_LABEL.2455']);
                                $.fancybox.close(true);
                                Hades.hideLoading();
                            }

                        })
                        .fail(function (xhr, status, error) {
                            Hades.showError();
                            Hades.hideLoading();
                        });


                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
            });
    }
}
